<template>
  <div class="d-flex flex-column w-100 h-100">
    <div class="pt-2 pr-2 text-right">
      <a href="#" @click="close"><i class="fa fa-2x fa-times" /></a>
    </div>

    <div class="pt-2 text-center">
      <span class="navbar-brand">{{ appTitle }}</span>
    </div>

    <div class="pt-3 d-flex flex-column align-items-center nav">
        <router-link v-for="(link, i) in links" :key="i" :to="link.to" class="nav-item w-100 text-center">
          <a class="nav-link w-100" @click="close">{{ link.title }}</a>
        </router-link>
    </div>
  </div>
</template>
<script>
  import UIConstants from '../../store/ui/constants'

export default {
  name: 'MobileMenu',
  props: {
    links: { type: Array }
  },
  methods: {
    close() {
      this.$store.dispatch(UIConstants.UIActions.UI_HIDE_MOBILE_MENU);
    }
  }
};
</script>
<style>
</style>
